export default __webpack_public_path__ + "static/media/firebase.addf245d.png";